import { render, staticRenderFns } from "./CommentaryPlusWidget.vue?vue&type=template&id=d10af9f6&scoped=true"
import script from "./CommentaryPlusWidget.vue?vue&type=script&lang=js"
export * from "./CommentaryPlusWidget.vue?vue&type=script&lang=js"
import style0 from "./CommentaryPlusWidget.vue?vue&type=style&index=0&id=d10af9f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10af9f6",
  null
  
)

export default component.exports